export default "__VITE_ASSET__BG0Voz3w__"